export default "/fonts/vendor/fontsource-roboto/files/roboto-greek-400-normal.woff2?352cc77aaed5208ce13c79cf9c89892f";